import React from "react";
import EpsIcon from '../../../assets/svg/eps.svg';
import FrameBlockResult from '../FrameBlockResult'
import { ApmsTypes } from "../../../constants";

const EpsResult = ({ link }) => {
    return (
        <FrameBlockResult link={link} apmType={ApmsTypes.EPS} icon={EpsIcon} />
    )
}

export default EpsResult;